import { render } from "./SystemUser.vue?vue&type=template&id=541c04d3"
import script from "./SystemUser.vue?vue&type=script&lang=js"
export * from "./SystemUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__